"use client";
import useBlogSearch, { BlogSearchArticlesFn, SearchFilterEntity } from "helpers/blog/useBlogSearch";
import { ArticlesList } from "./ArticlesList";
import { BlogSearch } from "./BlogSearch";
import { TaxonomiesList, TaxonomiesListItem } from "./TaxonomiesList";
import { PropsWithChildren, useState } from "react";
import { LoadingSpinnerWrapper } from "../../../UI/LoadingSpinnerWrapper";
import { BlogPaginationProps } from "@/components/pages/blog/BlogPagination";
import { useClientPagination } from "@/helpers/blog/useClientPagination";
import { ArticleListItemData } from "@/types/strapi/article";

const BLOG_DEFAULT_ARTICLES_PER_PAGE = 24;

type SearchEngineProps = {
  listClassName?: string;
  taxonomyHeading?: string;
  showSubcategory?: boolean;
  isSearch: boolean;
  isLoading: boolean;
  filteredArticles: ArticleListItemData[];
  pagination: BlogPaginationProps;
};

export const SearchEngine = ({
  children,
  isSearch,
  isLoading,
  filteredArticles,
  listClassName,
  pagination,
  showSubcategory,
}: PropsWithChildren<SearchEngineProps>) => {
  return (
    <>
      {!isSearch && children}
      {isSearch && (
        <LoadingSpinnerWrapper isLoading={isLoading}>
          <ArticlesList
            list={filteredArticles}
            className={listClassName}
            showSubcategory={showSubcategory}
            pagination={pagination}
          />
        </LoadingSpinnerWrapper>
      )}
    </>
  );
};
